import { render, staticRenderFns } from "./GlobalNotesSelector.vue?vue&type=template&id=11c59d39&scoped=true&"
import script from "./GlobalNotesSelector.vue?vue&type=script&lang=js&"
export * from "./GlobalNotesSelector.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNotesSelector.vue?vue&type=style&index=0&id=11c59d39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c59d39",
  null
  
)

export default component.exports